<template>
    <div>
        <section class="contact-hero" data-aos="fade-up">
            <span class="eyebrow-tag"> تماس با ما </span>
            <h1 class="hero-title">
                <span class="gradient-text"> شنیدن </span>
                شما برای ما اهمیت دارد
            </h1>
            <p class="hero-desc">
                هر پیشنهاد، گزارش خطا یا حرف ساده‌ای از طرف شما، به ما در ساختن
                نسخه‌ی بهتر لایوی کمک می‌کند.
            </p>
        </section>

        <section class="contact-content">
            <div class="contact-grid">
                <div class="info-column" data-aos="fade-up" data-aos-delay="100">
                    <div class="quote-block">
                        <div class="quote-mark">"</div>
                        <p>ما معتقدیم که بهترین محصولات با گوش دادن به کاربران ساخته می‌شوند.</p>
                        <span class="quote-author">— تیم لایوی</span>
                    </div>
                    <div class="info-card">
                        <div class="info-icon icon-mail">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <path
                                        d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                        </div>
                        <div class="info-text">
                            <h4>ارتباط</h4>
                            <p>در صورت نیاز با شما ارتباط می‌گیریم</p>
                        </div>
                    </div>
                    <div class="info-card">
                        <div class="info-icon icon-clock">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <polyline points="12 6 12 12 16 14" />
                            </svg>
                        </div>
                        <div class="info-text">
                            <h4>زمان پاسخگویی</h4>
                            <p>حداکثر ۲۴ ساعت</p>
                        </div>
                    </div>
                    <div class="info-card">
                        <div class="info-icon icon-shield">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            </svg>
                        </div>
                        <div class="info-text">
                            <h4>حریم خصوصی</h4>
                            <p>اطلاعات شما محفوظ است</p>
                        </div>
                    </div>
                </div>
                <div class="form-column" data-aos="fade-up" data-aos-delay="200">
                    <div class="form-card">
                        <div class="form-header">
                            <h2>ارسال پیام</h2>
                            <p>فرم زیر را پر کنید، در اسرع وقت پاسخ می‌دهیم.</p>
                        </div>
                        <form @submit.prevent="submitForm" class="contact-form">
                            <div class="form-field">
                                <label for="email">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2"
                                         stroke-linecap="round" stroke-linejoin="round">
                                        <circle cx="12" cy="12" r="4" />
                                        <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
                                    </svg>
                                    آدرس ایمیل
                                </label>
                                <input
                                        type="email"
                                        v-model="form.email"
                                        id="email"
                                        placeholder="example@email.com"
                                        required
                                        class="field-input"
                                        :class="{ 'field-filled': form.email }"
                                        dir="ltr"
                                />
                            </div>
                            <div class="form-field">
                                <label for="message">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2"
                                         stroke-linecap="round" stroke-linejoin="round">
                                        <path
                                                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                    </svg>
                                    پیام شما
                                </label>
                                <textarea
                                        v-model="form.message"
                                        id="message"
                                        rows="5"
                                        placeholder="پیام خود را اینجا بنویسید..."
                                        required
                                        class="field-input field-textarea"
                                        :class="{ 'field-filled': form.message }"
                                ></textarea>
                                <span class="char-count" :class="{ 'count-warn': form.message.length > 900 }">
                                    {{ form.message.length }} / 1000
                                </span>
                            </div>
                            <button type="submit" class="submit-btn" :disabled="loading">
                                <span v-if="loading" class="btn-loading">
                                    <span class="spinner"></span>در حال ارسال...</span>
                                <span v-else class="btn-content">
                                    ارسال پیام
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                         stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M19 12H5M12 5l-7 7 7 7" />
                                    </svg>
                                </span>
                            </button>
                            <p class="form-note">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                </svg>
                                در صورت نیاز از طریق ایمیل با شما در ارتباط خواهیم بود.
                            </p>
                        </form>
                        <transition name="msg-fade">
                            <div v-if="successMessage" class="msg msg-success">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                    <polyline points="22 4 12 14.01 9 11.01" />
                                </svg>
                                {{ successMessage }}
                            </div>
                        </transition>
                        <transition name="msg-fade">
                            <div v-if="errorMessage" class="msg msg-error">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <line x1="15" y1="9" x2="9" y2="15" />
                                    <line x1="9" y1="9" x2="15" y2="15" />
                                </svg>
                                {{ errorMessage }}
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import AOS from "aos";
import { buildMeta } from "@/utils/seo";

export default {
    name: "ContactUs",
    metaInfo() {
        return buildMeta({
            title: "تماس با ما | لایوی",
            description: "برای ارتباط با تیم لایوی و ارسال پیشنهادها، انتقادها و سؤالات خود با ما در تماس باشید.",
            path: "/contactus",
            type: "website",
        });
    },
    data() {
        return {
            form: { email: "", message: "" },
            loading: false,
            successMessage: "",
            errorMessage: ""
        };
    },
    created() {
        AOS.init({ once: true });
    },
    methods: {
        async submitForm() {
            this.loading = true;
            this.successMessage = "";
            this.errorMessage = "";

            try {
                const response = await axios.post(`${this.$serverUrl}/contact`, this.form);
                this.successMessage = "پیام شما با موفقیت ارسال شد!";
                this.form = { email: "", message: "" };
            } catch (error) {
                this.errorMessage = "مشکلی پیش آمد، لطفاً دوباره تلاش کنید.";
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~aos/dist/aos.css';
@import "@/assets/css/tokens";

.contact-hero {
    max-width: 720px;
    margin: 0 auto;
    padding: 6rem 1.5rem 1rem;
    text-align: center;
}

.hero-title {
    font-size: clamp(1.9rem, 4.3vw, 2.8rem);
    font-weight: 900;
    line-height: 1.4;
    margin: 0.6rem 0 1rem;
}

.hero-desc {
    font-size: 1rem;
    color: $text-secondary;
    line-height: 2.05;
    margin: 0 auto;
    max-width: 540px;
}

.contact-content {
    padding: 2rem 2rem 4rem;
    max-width: 1100px;
    margin: 0 auto;
}

.contact-grid {
    display: grid;
    grid-template-columns: 340px 1fr;
    gap: 2.5rem;
    align-items: start;
}

.info-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.info-card {
    display: flex;
    align-items: center;
    gap: 1rem;
    background: $bg-card;
    border: 1px solid $border-light;
    border-radius: 16px;
    padding: 1.2rem 1.4rem;
    transition: all 0.3s ease;

    &:hover {
        border-color: rgba($accent-cyan, 0.25);
        box-shadow: 0 4px 20px rgba($accent-cyan, 0.06);
        transform: translateY(-2px);
    }
}

.info-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.icon-mail {
    background: rgba($accent-cyan, 0.08);
    color: $accent-cyan;
}

.icon-clock {
    background: rgba($accent-blue, 0.08);
    color: $accent-blue;
}

.icon-shield {
    background: rgba($accent-purple, 0.08);
    color: $accent-purple;
}

.info-text {
    h4 {
        font-size: 0.9rem;
        font-weight: 700;
        margin: 0 0 0.15rem;
        color: $text-primary;
    }
    p {
        font-size: 0.82rem;
        color: $text-muted;
        margin: 0;
        direction: ltr;
        text-align: right;
    }
}

.quote-block {
    margin-top: 0.5rem;
    background: $gradient-soft;
    border-radius: 16px;
    padding: 1.5rem 1.6rem 1.2rem;
    position: relative;
}

.quote-mark {
    font-size: 3.5rem;
    font-weight: 900;
    line-height: 1;
    background: $gradient-main;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: absolute;
    top: 0.4rem;
    right: 1.2rem;
    opacity: 0.4;
}

.quote-block p {
    font-size: 0.9rem;
    color: $text-secondary;
    line-height: 1.9;
    margin: 0 0 0.6rem;
    padding-top: 0.8rem;
}

.quote-author {
    font-size: 0.78rem;
    color: $text-muted;
    font-weight: 600;
}

.form-card {
    background: $bg-card;
    border: 1px solid $border-light;
    border-radius: 24px;
    padding: 2.5rem 2.5rem 2rem;
    position: relative;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 8px 30px rgba(0, 0, 0, 0.04);

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: $gradient-main;
    }
}

.form-header {
    margin-bottom: 2rem;

    h2 {
        font-size: 1.5rem;
        font-weight: 800;
        margin: 0 0 0.5rem;
    }
    p {
        font-size: 0.9rem;
        color: $text-muted;
        margin: 0;
    }
}

.contact-form {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.form-field {
    position: relative;

    label {
        display: flex;
        align-items: center;
        gap: 0.4rem;
        font-size: 0.85rem;
        font-weight: 600;
        color: $text-primary;
        margin-bottom: 0.5rem;

        svg {
            color: $text-muted;
        }
    }
}

.field-input {
    width: 100%;
    background: $bg-page;
    border: 1.5px solid $border-light;
    border-radius: 14px;
    padding: 0.85rem 1.1rem;
    font-family: "Vazirmatn", sans-serif;
    font-size: 0.95rem;
    color: $text-primary;
    transition: all 0.25s ease;
    outline: none;
    &::placeholder {
        color: $text-muted;
        font-size: 0.85rem;
    }
    &:focus {
        border-color: $accent-blue;
        background: #fff;
        box-shadow: 0 0 0 4px rgba($accent-blue, 0.08);
    }
    &.field-filled {
        border-color: rgba($accent-teal, 0.3);
        background: #fff;
    }
}

.field-textarea {
    resize: vertical;
    min-height: 130px;
    line-height: 1.8;
}

.char-count {
    position: absolute;
    bottom: 0.6rem;
    left: 0.9rem;
    font-size: 0.7rem;
    color: $text-muted;
    direction: ltr;
    &.count-warn {
        color: #ef4444;
    }
}

.submit-btn {
    width: 100%;
    background: $gradient-main;
    color: #fff;
    border: none;
    border-radius: 12px;
    padding: 0.9rem 2rem;
    font-family: "Vazirmatn", sans-serif;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba($accent-blue, 0.2);
    margin-top: 0.5rem;
    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 8px 30px rgba($accent-blue, 0.25);
    }
    &:active:not(:disabled) {
        transform: translateY(0);
    }
    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
}

.btn-content,
.btn-loading {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.spinner {
    width: 18px;
    height: 18px;
    border: 2.5px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.form-note {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    font-size: 0.78rem;
    color: $text-muted;
    margin: 0;
    svg {
        color: $accent-teal;
        flex-shrink: 0;
    }
}

.msg {
    display: flex;
    align-items: center;
    gap: 0.7rem;
    padding: 1rem 1.2rem;
    border-radius: 14px;
    font-size: 0.9rem;
    font-weight: 600;
    margin-top: 1.2rem;
}

.msg-success {
    background: rgba(#10b981, 0.08);
    border: 1px solid rgba(#10b981, 0.2);
    color: #059669;
}

.msg-error {
    background: rgba(#ef4444, 0.08);
    border: 1px solid rgba(#ef4444, 0.2);
    color: #dc2626;
}

.msg-fade-enter-active,
.msg-fade-leave-active {
    transition: all 0.4s ease;
}

.msg-fade-enter,
.msg-fade-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

@media (max-width: 900px) {
    .hero-inner {
        grid-template-columns: 1fr;
        text-align: center;
    }
    .hero-visual {
        order: -1;
    }
    .hero-desc {
        margin: 0 auto;
    }
    .hero-map-img {
        max-width: 280px;
    }
    .contact-grid {
        grid-template-columns: 1fr;
    }
    .info-column {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 0.8rem;
    }
    .quote-block {
        grid-column: 1 / -1;
    }
    .form-card {
        padding: 2rem 1.5rem 1.5rem;
    }
}
</style>
